import React from 'react';
import {
  formatPriorityLabel,
  formatPriorityShortLabel,
  getPriorityDisplayLabel,
  getPriorityBadgeClass,
  normalizeRequirementPriority,
} from '../../utils/requirementPriority';

function PriorityBadge({ priority, className = '', shortLabel = false }) {
  const normalized = normalizeRequirementPriority(priority);
  if (normalized === null) {
    if (shortLabel) return null;
    return (
      <span
        className={`hr-priority-badge hr-priority-none ${className}`.trim()}
        title="No priority assigned"
      >
        —
      </span>
    );
  }

  const badgeClass = getPriorityBadgeClass(priority);
  const label = shortLabel ? formatPriorityShortLabel(priority) : formatPriorityLabel(priority);
  const title = getPriorityDisplayLabel(priority) || 'No priority assigned';

  return (
    <span className={`${badgeClass} ${className}`.trim()} title={title}>
      {label}
    </span>
  );
}

export default PriorityBadge;
